import {Component, NgZone, OnInit} from '@angular/core';
import {AuthService} from '../../service/main/auth.service';
import {SettingsService} from '../../service/common/settings.service';
import {Router} from '@angular/router';
import {AddInstitutionService} from '../../service/main/add-institution.service';
import {ToastrService} from '../../service/common/toastr.service';


@Component({
  selector: 'app-add-institutions',
  templateUrl: './add-institutions.component.html',
  styleUrls: ['./add-institutions.component.css']
})
export class AddInstitutionsComponent implements OnInit {

  title: string;
  cui: string;
  bankAccount: string;
  location: string;
  address: string;
  contactName: string;
  phoneNumber: string;
  email: string;
  user: string;
  password: string;

  constructor(private authService: AuthService,
              private settings: SettingsService,
              private router: Router,
              private addInstitutionService: AddInstitutionService,
              private toastr: ToastrService) {
  }

  ngOnInit() {

  }

  addInstitutions() {
    const institution = {
      title: this.title,
      identifier: this.cui,
      bankAccount: this.bankAccount,
      location: this.location,
      address: this.address,
      contactName: this.contactName,
      contactPhone: '0'+this.phoneNumber,
      contactEmail: this.email,
      user: this.user,
      password: this.password
    };
    this.addInstitutionService.addInstitution(institution).subscribe(data => {
      this.toastr.success('Institution successfully added.');
      this.title = null;
      this.cui = null;
      this.bankAccount = null;
      this.location = null;
      this.address = null;
      this.contactName = null;
      this.phoneNumber = null;
      this.email = null;
      this.user = null;
      this.password = null;
      this.router.navigate(['institutions']);
    }, (err) => {
      this.toastr.error('An error occurred while adding the institution.');
    });

  }
  cancel(){
    this.router.navigate(['institutions']);
  }
}
